import Box from '@mui/material/Box';
import './bnrFonts.css';
import { useOutletContext } from 'react-router-dom';
import LogoChip from '../components/LogoChip';

function EmbeddedBaseView({ children }) {
    const { election } = useOutletContext() ?? { election: null };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%'
            }}>
            <Box
                sx={{
                    backgroundColor: '#F5F5F5',
                    borderLeft: '5px solid #ffd200',
                    width: '100%',
                    height: '100%',
                    position: 'relative'
                }}>
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '0px',
                        right: '5px',
                        borderRadius: '10px',
                        p: '3px',
                        zIndex: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        gap: '20px'
                    }}>
                    <img
                        src="/logo_green.svg"
                        height={20}
                        style={{ display: 'block' }}
                        alt="logo"
                    />
                    <LogoChip election={election} sx={{ fontSize: 8 }} />
                </Box>
                {children}
            </Box>
        </Box>
    );
}

export default EmbeddedBaseView;
